import React from 'react';
import routes from '../../model/router';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,Card,
  } from 'antd';
import '../../assets/css/App.css';
import Header1 from '../public';

const {
    Header, Content, Footer, Sider,
  } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

class Graduates extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div>
                <div>
                  <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['3']}
                    defaultOpenKeys={['sub2']}
                    style={{ height: '100%' }}
                  >
                  <SubMenu key="sub1" title={<span><Icon type="user" />Staff</span>}>
                      <Menu.Item key="1"><Link to="/director">Director</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/member">Member</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub2" title={<span><Icon type="user" />Students</span>}>
                      <Menu.Item key="3"><Link to="/graduates">Graduates</Link></Menu.Item>
                      <Menu.Item key="4"><Link to="/intern-doctors">Intern doctors</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                        <Content style={{ padding: '200 200px', minHeight: 280 }}>
                        


                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/nx.jpg')} />}>
                                    <Meta
                                        title="Nan Xu"
                                        description="College of Health Management CMU"
                                    />
                                </Card>,
                          </div>

                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/hz.jpg')} />}>
                                    <Meta
                                        title="He Zhou"
                                        description="College of Health Management CMU"
                                    />
                                </Card>,
                          </div>
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}

                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/sxn.jpg')} />}>
                                    <Meta
                                        title="Shuxian Niu"
                                        description="Biomedical Engineering CMU"
                                    />
                                </Card>,
                          </div>

                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{ width: 240}}
                                    cover={<img src={require('../../assets/images/zjc.png')} />}>
                                    <Meta
                                        title="Zongjian Chen"
                                        description="College of Health Management CMU"
                                    />
                                </Card>,
                          </div>

                         
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}
                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/jqx.png')} />}>
                                    <Meta
                                        title="Jiaqi Xu"
                                        description="College of Health Management CMU"
                                    />
                                </Card>,
                          </div>
                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/cww.jpg')} />}>
                                    <Meta
                                        title="Chongwei Wu"
                                        description="Biomedical Engineering CMU"
                                    />
                                </Card>,
                          </div>
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}
                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/tj.jpg')} />}>
                                    <Meta
                                        title="Tao Jiang"
                                        description="Biomedical Engineering CMU"
                                    />
                                </Card>,
                          </div>
                          
                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/qx.jpg')} />}>
                                    <Meta
                                        title="Qiong Xiao"
                                        description="Institute of Health Sciences CMU"
                                    />
                                </Card>,
                          </div>
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}
                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                                <Card
                                    hoverable
                                    style={{width: 240}}
                                    cover={<img src={require('../../assets/images/yf.jpg')} />}>
                                    <Meta
                                        title="Yu Fu"
                                        description="Institute of Health Sciences CMU"
                                    />
                                </Card>,
                          </div>
                        </Content>
                    </Layout>
            </Content>
            </div>
            </div>
        )
    }
}
export default Graduates;